document.addEventListener('alpine:init', () => {
  Alpine.data('paceCal', () => ({
    loading: false,
    options: trainingPlans,
    selectedOptionIndex: 0,
    selectedOption: {},
    defaultPlan: document.querySelector('#paceCalculator').dataset.defaultPlan,
    handleUpdatePlan() {
      this.loading = true
      this.setCalcValuesFromSelectedOption()
      this.setURLParamsFromInputValue()

      setTimeout(() => {
        this.loading = false
        this.handleScrollTo()
        window.planDefaultValues();
        window.tableUnit();
        window.milesToKmChartUnits();
        window.estTime();
        window.showDistanceForPrictedTime();
      }, 1000);
    },

    handleScrollTo() {

      const element = document.querySelector(".pace-calculator")
      const offset = 60;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;
      // scroll to position
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });

    },
    setCalcValuesFromSelectedOption() {
      this.selectedOption = this.options[this.selectedOptionIndex]
      console.log("🚀 ~ file: pace-calculator.js:41 ~ setCalcValuesFromSelectedOption ~ this.selectedOption:", this.selectedOption)
      window.planDistance = this.options[this.selectedOptionIndex].plan_distance; //distance run
      window.planDistanceUnit = this.options[this.selectedOptionIndex].plan_distance_unit //distance Unit should be same to [mile , km]
      window.planHours = this.options[this.selectedOptionIndex].plan_hours //Hours
      window.planMins = this.options[this.selectedOptionIndex].plan_mins //minuts
      window.planSec = this.options[this.selectedOptionIndex].plan_sec //seconds
      window.planEstDis = this.options[this.selectedOptionIndex].plan_est_dis //estimated Distance
      window.planEstDisUnit = this.options[this.selectedOptionIndex].plan_est_dis_unit //estimated Unit should be same to [mile , km]

    },

    setURLParamsFromInputValue() {
      const urlParams = new URLSearchParams(window.location.search);
      const handleize = this.selectedOption.input_name.replace(/\s+/g, '-').toLowerCase();

      urlParams.set('planId', handleize);
      window.history.pushState({}, '', `${location.pathname}?${urlParams}`);
    },


    initializeComponent() {
    console.log("🚀 ~ file: pace-calculator.js:62 ~ initializeComponent ~ initializeComponent:")
      const urlParams = new URLSearchParams(window.location.search);
      const planIdParam = this.defaultPlan ? this.defaultPlan.replace(/\s+/g, '-').toLowerCase() : urlParams.get('planId');

      if (!planIdParam) {
        return;
      }

      let matchIndex = trainingPlans.findIndex((plan, index) => {
        return planIdParam == plan.input_name.replace(/\s+/g, '-').toLowerCase();
      })
      
      if (matchIndex > -1) {
        setTimeout(() => {
          this.selectedOptionIndex = matchIndex;
          this.handleUpdatePlan();
        }, 0);
      }
    }
  }))

  console.log("🚀 ~ file: pace-calculator.js:84 ~ document.addEventListener ~ alpine:init:")


  window.unitMile = "mile";
  window.unitKm = "km";
  window.paceCookie = "paceCookie-unit";
  window.unitOfChart = unitMile;

  //read first time user default unit for chart and table [estimated unit]
  var cookieunit = getCookie(paceCookie);


  if (cookieunit) {
    window.measurement = cookieunit;
  } else {
    if (window.planEstDisUnit) {
      if (window.planEstDisUnit.includes("mile")) {
        window.measurement = unitMile;
      } else window.measurement = unitKm;
    } else {
      //make default for unit Mile
      window.measurement = unitOfChart;
    }
  }

  var showmeasurement = measurement;

  /*
   **this is for the first time run
   **here we will set values and check for all things
   */

  //submit action



  // document.addEventListener('calc:tableInit', function(event) {

  document.querySelector("#paceCalculator").addEventListener("submit", (event) => {
    event.preventDefault();
    unitEst();
    tableUnit();
    milesToKmChartUnits();
    estTime();

    showDistanceForPrictedTime();

    document.getElementById("resetButton").style.opacity = "1";
  });

  //reset form action
  document.querySelector("form").addEventListener("reset", (event) => {
    //PREVENT DEFAULT
    event.preventDefault();

    planDefaultValues();

    //this will reset the cookie unit and whole cart / table unit to default cart unit predefined.
    unitEst(planEstDisUnit);

    tableUnit();
    milesToKmChartUnits();
    estTime();
    showDistanceForPrictedTime();
    document.getElementById("resetButton").style.opacity = "0";

    // document.getElementById("toggle-measurement").style.display = "none";
    // document.getElementById("distanceEstimatedLabel").style.display = "none";

    //   document.getElementsByName("lengthEst")[0].removeAttribute("disabled");
    //   document.getElementsByName("unitsEst")[0].removeAttribute("disabled");
    //   document.getElementById("submitbtn").removeAttribute("disabled");
    // let a = document.querySelectorAll("[id=whiteInput]");
    // a.forEach((item) => {
    //   item.removeAttribute("disabled");
    // });
  });

  //button to convert km to mile
  document.querySelector("#toggle-measurement").addEventListener("click", (e) => {
    e.preventDefault();
    convertWholeChartToDifferentUnit();
  });

  //button to convert km to mile
  document.querySelector("#other-togglebutton").addEventListener("click", (e) => {
    e.preventDefault();
    convertWholeChartToDifferentUnit();
  });

// });


})
